module.exports = __webpack_public_path__ + "static/media/cover-button_cn1.f4c96b5d.png";